module.exports = __webpack_public_path__ + "img/alex.13aaa783.jpg";